module.exports = __webpack_public_path__ + "static/media/parking.08c03028.png";